/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  Graph,
  DetailsPayments,
  DetailsPayouts,
  Button,
  Title,
  Paper,
  Spinner,
  DateRangePicker,
  Table,
  TableFooter
} from '../../components';

import * as actions from '../../actions/index';
import { initializeFinance, onChangeSelection, onSelectDate, calculateFinanceData } from './Finances.services';
import { getInitialDateRange } from '../../utils/suitableDate';
import { styles } from './Finances.styles';
import { FINANCE_TABLE_HEAD } from '../../constants/table';
import _ from 'lodash';

const TableCell = withStyles({
  root: {
    paddingRight: '10px'
  }
})(MuiTableCell);

class Finances extends Component {
  state = {
    isLoading: true,
    isLoadingDate: false,
    accesArray: [],
    dateRange: getInitialDateRange()
  };

  async componentDidMount() {
    const { isAllShops } = this.props;
    await initializeFinance(isAllShops, this);
    await this.props.getFinishedOrders(null, this.state.dateRange, true, isAllShops);
  }

  async componentWillReceiveProps(props) {
    const { shopId: oldShopId, isAllShops: oldIsAllShops } = this.props;
    const { shopId, isAllShops } = props;
    if (shopId !== oldShopId || (shopId === oldShopId && oldIsAllShops !== isAllShops)) {
      await initializeFinance(isAllShops, this);
    }
  }

  renderStatusFinances = () => {
    return (
      <Button
        color='secondary'
        outlined
        className='btn-xs-block'
        onClick={() => {
          const { showModal } = this.props;
          const modalData = {
            color: 'secondary',
            title: 'Détails des paiements',
            children: <DetailsPayments />,
            header: true,
            btn: 'Default',
            showCancelBtn: false,
            width: '700px',
            fixed: true
          };
          showModal(modalData);
        }}
      >
        Détails des paiements
      </Button>
    );
  };

  renderPaymentTypeButton = (name, type, tab) => {
    const { classes } = this.props;
    return (
      <Grid item md={0}>
        <Button
          variant='contained'
          component='span'
          size='medium'
          className={classes.button}
          onClick={e => onChangeSelection(e, type, tab)}
        >
          {name}
        </Button>
      </Grid>
    );
  };
  createTableRow = (rows) => {
    const { classes } = this.props;
    return (
      <TableBody>
        {_.map(rows, (e, index) => {
          const { CA, moy, nbCmd, rate, name, shopId, canceledCmd, missedCmd } = e;
          return (
            <TableRow key={shopId} style={{ cursor: 'pointer' }}>
              <TableCell align="center" className={classes.valueC}>
                {name === 'Total' ? <b>Total</b> : name}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {`${CA?.toFixed(2)} €`}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {nbCmd}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {canceledCmd}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {missedCmd}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {`${moy?.toFixed(2)} €`}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {`${rate === 0 ? 0 : rate?.toFixed(2)} %`}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  render() {
    const { classes, seedData, showHelpModal, isAllShops, finances, finishedOrders, page, shops, customAccountId } = this.props;
    const { isLoading, dateRange, isLoadingDate } = this.state;
    const { shopResults = {} } = isAllShops ? finances['global'] : finances['shop'];
    const { numPage, rowsPerPage } = page;
    const calculatedRows = calculateFinanceData(seedData, finishedOrders, shopResults, numPage, rowsPerPage, shops, isAllShops);

    return (
      <div className='px-4 pb-4'>
        <Title title='Finances' onClick={() => showHelpModal('finances')} />
        {isLoading ? (
          <center>
            <Spinner className={classes.progress} />
          </center>
        ) : (
          <div>
            <div className='py-3'>
              <Paper>
                <div className='p-3'>
                  <div className='row mb-3'>
                    <div className='col-12 col-sm-4 align-self-center'>
                      <div className='row'>
                        <div className='col-12'>
                          <DateRangePicker
                            btnClassName='btn-xs-block'
                            className='mr-0 mr-sm-3'
                            dateRange={dateRange}
                            onSelectDate={dateRange => {
                              onSelectDate(this, dateRange);
                            }}
                            disabled={isLoadingDate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='col-sm-8 d-sm-flex flex-row-reverse mt-3 mt-sm-0 '>
                      <div className='d-flex ml-sm-2'>
                        {!isAllShops && this.renderStatusFinances()}
                      </div>
                      <div className='d-flex mt-3 mt-sm-0 '>
                        {(!isAllShops || customAccountId) && (
                          <Button
                            color='secondary'
                            outlined
                            className='btn-xs-block mr-0'
                            onClick={() => {
                              const { showModal } = this.props;
                              const modalData = {
                                color: 'secondary',
                                title: 'Historique des virements',
                                children: <DetailsPayouts isAllShops={isAllShops} />,
                                header: true,
                                showCancelBtn: false,
                                width: '700px',
                                fixed: true
                              };
                              showModal(modalData);
                            }}
                          >
                            Historique des virements
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  {isLoadingDate && (
                    <div className='my-5'>
                      <center>
                        <Spinner className={classes.progress} />
                      </center>
                    </div>
                  )}
                  {!isLoadingDate && (
                    <div>
                      <div className={classes.graph}>
                        <Graph />
                      </div>
                      <div className='mt-3'>
                        <Table
                          headCells={FINANCE_TABLE_HEAD}
                          classes={classes}
                          bodyRows={calculatedRows}
                          createTableRow={(rows) => this.createTableRow(rows)}
                          order={`${isAllShops && 'asc'}`}
                          orderBy={`${isAllShops && 'name'}`}
                        />
                        {isAllShops &&
                          <TableFooter lengthOption={_.keys(calculatedRows).length} />
                        }
                      </div>

                    </div>
                  )}

                </div>
              </Paper>
            </div>
          </div>
        )}
      </div>
    );
  }
}
Finances.propTypes = {
  classes: PropTypes.element.isRequired
};

const mapStateToProps = ({ finances, user, firebaseRealTime, orders, page }) => {
  const { nbShops, shopId, shopName, servicePrice = {}, companyId, isAllShops } = user;
  const { finance, financeGlobalData, shops, generalConfig } = firebaseRealTime;
  const { selectedTableau, selectedGraph, selectedEntity } = finances;
  const { fees = {} } = servicePrice;
  const { finishedOrders = [] } = orders;
  const { servicePrice: generalServicePrice = {} } = generalConfig;
  const { customAccountId } = generalServicePrice;
  return {
    seedData: (finances[selectedEntity] && finances[selectedEntity][selectedTableau]) || [],
    detailsPayments: (finances[selectedEntity] && finances[selectedEntity].details) || [],
    contract: fees.contract,
    paymentFees: fees.stripe,
    brutFinance: finance,
    brutGobalFinance: financeGlobalData,
    nbShops,
    shopId,
    shopName,
    selectedGraph,
    selectedTableau,
    selectedEntity,
    companyId,
    isAllShops,
    finances,
    shops,
    finishedOrders,
    page,
    customAccountId
  };
};

export default compose(withStyles(styles), connect(mapStateToProps, actions))(Finances);
